export default {
  views: {
    subGroups: {
      assign: "กำหนดกลุ่มย่อย",
      tagManager: "ผู้จัดการแท็ก: เลือกกลุ่มของคุณ",
      successAssign: "อัศจรรย์! คุณได้อัปเดตกลุ่มย่อยสำหรับกลุ่มของคุณแล้ว",

      errors: {
        assign: "เอ่อโอ้! ไม่สามารถกำหนดกลุ่มย่อย"
      },

      table: {
        firstName: "ชื่อจริง",
        lastName: "นามสกุล",
        username: "ชื่อผู้ใช้",
        subGroup: "กลุ่มย่อย"
      }
    },

    classes: {
      label: "กลุ่ม",

      editGroup: "แก้ไขกลุ่ม - ขั้นตอน  ",
      addGroup: "เพิ่มกลุ่ม - ขั้นตอน ",
      classesCount: "{count} กลุ่ม",

      errors: {
        group: "ไม่สามารถโหลดข้อมูลกลุ่ม",
        update: "ไม่สามารถอัพเดทกลุ่มได้สำเร็จ  กรณาลองอีกครั้ง",
        create: "ยังสร้างกลุ่มไม่สำเร็จ",
        emptyList: "ขณะนี้ยังไม่มีกลุ่มของคุณในโรงเรียนที่เลือกเลย"
      },

      messages: {
        create: "สร้างกลุ่มเสร็จเรียบร้อยแล้ว"
      }
    },

    schools: {
      label: "โรงเรียน",

      errors: {
        emptyList: "ตอนนี้ยังไม่มีโรงเรียนที่คุณเข้าร่วมได้",
        fetchError: "ไม่สามารถดึงข้อมูลโรงเรียน"
      }
    },

    teachers: {
      teachersCount: "{count} ครูผู้สอน",

      errors: {
        emptyList: "คุณยังไม่มีครูในขณะนี้",
        details: "ดึงข้อมูลครูไม่สำเร็จ"
      },

      titles: {
        edit: "แก้ไขรายละเอียดเกี่ยวกับครู"
      },

      messages: {
        create: "สร้างครูสำเร็จ",
        update: "อัพเดทครูแล้ว"
      }
    },

    grammarToGo: {
      title: "ไวยากรณ์ฉบับพกพา"
    },

    home: {
      wantToAssign: "ต้องการมอบหมายบทเรียน",
      whatStudentsDo: "นักเรียนของคุณทำอะไรใน Little Bridge",
      howManyCountries: "นักเรียนของคุณมี DigiPalsในกี่ประเทศ",
      numActivities: "นักเรียนของคุณได้ทำกิจกรรมไปแล้วกี่กิจกรรม",
      numFriends: "นักเรียนของคุณมี DigiPals กี่คน",
      numMessages: "นักเรียนของคุณส่งข้อความไปแล้วกี่ข้อความ",

      errors: {
        dashboard: "ไม่สามารถดึงข้อมูลแดชบอร์ดได้/ดึงข้อมูลdashboardไม่สำเร็จ"
      }
    },

    knowledgeBase: {
      title: "ฐานความรู้",

      errors: {
        fetch: "ไม่สามารถดึงข้อมูลฐานความรู้ได้/ดึงข้อมูลฐานความรู้ไม่สำเร็จ",
        details:
          "ไม่สามารถดึงข้อมูลรายละเอียดฐานความรู้ได้/ดึงข้อมูลรายละเอียดฐานความรู้ไม่สำเร็จ"
      }
    },

    lessons: {
      label: "บทเรียน",

      subgroups: "กลุ่มย่อย",

      messages: {
        setLessonsAuto:
          "Little Bridge จะแพลนการเรียนของนักเรียนให้โดยอัตโนมัติ นักเรียนสามารถเรียนได้ตามระดับความสามารถของตน คุณสามารถแทนที่ได้ตลอดเวลาโดยการกำหนดบทเรียนให้นักเรียนเอง"
      },

      hasBeenAssigned: "ได้กำหนดบทเรียนนี้เรียบร้อยแล้ว",
      assignAnother: "มอบหมายอีกบทเรียนหนึ่ง",
      assignMyself: "ต้องการกำหนดบทเรียนเอง",
      assignAuto: "ต้องการให้ Little Bridge กำหนดบทเรียนให้โดยอัตโนมัติ",
      lessonId: "บทเรียน  {lessonId}",
      set: "กำหนดบทเรียน",
      activity: "กิจกรรม",
      resources: "ทรัพยากร",

      statuses: {
        selected: "บทเรียนที่เลือก",
        archived: "จัดเก็บ",
        current: "บทเรียนปัจจุบัน",
        unassigned: "ยังไม่ได้มอบหมาย (บทเรียนนี้)"
      },

      stepper: {
        titles: {
          step1: "ขั้นตอนที่ 1 - ต้องการกำหนดบทเรียนนี้ให้ใคร",
          step2: "ขั้นตอนที่ 2 - เลือกบทเรียน",
          step3: "ขั้นตอนที่ 3 - ยืนยัน"
        }
      },

      errors: {
        fetch: "ไม่สามารถดึงข้อมูลบทเรียนได้/ดึงข้อมูลบทเรียนไม่สำเร็จ"
      }
    },

    reports: {
      title: "ตัวสร้างรายงาน",
      type: "ประเภทรายงาน",
      generate: "สร้างรายงาน",

      level: "รายงานระดับ",
      lesson: "รายงานบทเรียน",

      test: "รายงานผลการประเมิน",
      diagnostic: "รายงานการวินิจฉัย",
      baseline: "รายงานพื้นฐาน",
      progress: "การทดสอบความก้าวหน้า",
      students: "นักเรียน",

      download: {
        pdf: "ดาวน์โหลดเป็น PDF",
        csv: "ดาวน์โหลด CSV",
        lessonPlan: "ดาวน์โหลดแผนการสอนรูปแบบไฟล์ PDF"
      },

      errors: {
        generate: "ไม่สามารถการสร้างรายงานสำเร็จ กรุณาลองใหม่อีกครั้ง"
      }
    },

    students: {
      label: "นักเรียน",
      editStudent: "แก้ไขนักเรียน",
      stundentsCount: "{count} นักเรียน",
      add: "เพิ่มนักเรียน",
      saveAndDownload: "บันทึกและดาวน์โหลดรายชื่อนักเรียน",
      download: "บันทึกและดาวน์โหลดรายชื่อนักเรียน",

      import: {
        step: "ขั้นตอน: นำเข้านักเรียน - ขั้นตอนที่ ",
        clickVideo: "คลิกที่นี่เพื่อดูวิดีโอกวดวิชาสั้นๆ",
        copyPasteFirst:
          "โปรด copy and paste ชื่อจริงของนักเรียนของคุณลงใน ช่อง ‘ชื่อจริง’ คุณสามารถนำนักเรียนเข้าได้ครั้งละ 100 คน",
        copyPasteLast:
          "โปรดคัดลอกและวางนามสกุลของนักเรียนของคุณลงในช่องข้อความ 'นามสกุล'",
        confirm:
          "โปรดตรวจสอบว่าทุกอย่างถูกต้อง คุณสามารถกลับไปแก้ไขได้ตลอดเวลา กรุณาตรวจสอบให้แน่ใจว่าชื่อจริงและนามสกุลนักเรียนตรงกัน",
        thoseStudentsAdded:
          "เพิ่มนักเรียนเหล่านี้ในบัญชีของคุณแล้ว ด้วยเหตุผลด้านความปลอดภัย คุณจะไม่สามารถดาวน์โหลดรหัสผ่านได้อีก โปรดตรวจสอบให้แน่ใจว่าคุณได้บันทึกไฟล์ที่ให้ไว้ในตำแหน่งที่ปลอดภัยบนคอมพิวเตอร์ของคุณ หากไฟล์ไม่ได้ดาวน์โหลดอัตโนมัติ โปรดคลิก ปุ่ม 'ดาวน์โหลดรายชื่อนักเรียน' ตอนนี้",
        note: "หมายเหตุ - จำกัดจำนวนนักเรียน 100 คนต่อการนำเข้า"
      },

      messages: {
        create: "สร้างนักเรียนสำเร็จแล้ว!",
        update: "อัพเดทนักเรียนแล้ว!"
      },

      errors: {
        emptyList: "คุณยังไม่มีนักเรียนเลย",
        details: "เรียกข้อมูลนักเรียนไม่สำเร็จ",
        import:
          "เอ่อโอ้! มีบางอย่างผิดพลาด คุณลองคัดลอกและวางชื่ออีกครั้งได้ไหม",
        importPaste: "เอ่อโอ้! คุณยังไม่ได้วางอะไรลงในคอลัมน์"
      }
    }
  },

  stepsLabels: {
    step4: "ขั้นตอนที่ 4 - ยืนยัน"
  },

  common: {
    next: "ต่อไป",
    ok: "ตกลง",
    unassigned: "ยังไม่ได้มอบหมาย",
    close: "ปิด",
    nextConfirm: "ขั้นตอนถัดไป - ยืนยัน",
    continue: "ดำเนินการต่อ",
    returnHome: "กลับหน้าแรก",
    finish: "เสร็จสิ้น",
    confirm: "ยืนยัน",
    save: "บันทึก",
    siteUsage: "การใช้งานเว็บไซต์",
    reset: "รีเซ็ต"
  },

  errors: {
    basic: "โหลดข้อมูลไม่สำเร็จ/ไม่สามารถโหลดข้อมูลได้",
    unexpected: "เกิดข้อผิดพลาดที่ไม่คาดคิด",
    admin: "กรุณาติดต่อเจ้าหน้าที่ผู้ดูแลบัญชีก่อนเพื่อขออนุญาตดำเนินการต่อ"
  },

  tables: {
    lessons: {
      level: "ระดับ",
      topic: "หัวข้อ",
      lesson: "บทเรียน",
      summary: "สรุป",
      content: "เนื้อหา",
      status: "สถานะ",
      testCategory: "หมวดการทดสอบ"
    },

    reports: {
      firstName: "ชื่อจริง",
      lastName: "นามสกุล",
      username: "ชื่อผู้ใช้",
      lesson: "บทเรียน",
      scoreForActivity: "คะแนน - {activityId}",
      correct: "แก้ไข",
      progress: "ความคืบหน้า",
      levelNumber: "ระดับ",
      lessonName: "ชื่อบทเรียน",
      topic: "หัวข้อ",
      activity1: "กิจกรรม 1",
      activity2: "กิจกรรมที่ 2",
      activity3: "กิจกรรมที่ 3",
      activity4: "กิจกรรมที่ 4"
    },

    classes: {
      subgroups: "กลุ่ม Alt",
      group: "กลุ่ม",
      teacher: "ครู",
      numberOfStudents: "จำนวนนักเรียน",
      lesson: "บทเรียนปัจจุบัน",

      errors: {
        failedDelete: "ยังลบกลุ่มไม่สำเร็จ กรุณาลองอีกครั้ง",
        canBeAssign:
          "นักเรียนจะได้รับมอบหมายให้อยู่ในกลุ่มเดียวเท่านั้น  ถ้าย้ายนักเรียนมากลุ่มนี้ก็จะถูกลบไปจากกลุ่มปัจจุบันทันที"
      }
    }
  },

  components: {
    noActivitiesInLesson: "ไม่มีกิจกรรมสำหรับบทเรียนนี้",
    selectAll: "เลือกทั้งหมด",
    groupName: "ชื่อกลุ่ม",
    assignStudents: "ขั้นตอนถัดไป - ใส่ชื่อนักเรียน",
    assignTeachers: "ขั้นตอนถัดไป - ใส่ชื่อครู",
    noData: "ยังไม่มีข้อมูลในขณะนี้",
    videoSupport: "ขออภัย เบราว์เซอร์ของคุณไม่สามารถรองรับวิดีโอนี้ได้",
    generateUsername: "สร้าง usernameใหม่",
    password: "รหัสผ่าน",
    admin: "แอดมิน",
    view: "ดู",
    goBack: "ย้อนกลับ",
    openLanguageMenu: "เปิดเมนูภาษา",
    isAdmin: "เป็นผู้ดูแลระบบ",
    selectALevel: "เลือกระดับ",

    warnings: {
      deleteClasses: "คุณกำลังจะลบชั้นเรียน {clasessNames}"
    },

    errors: {
      selectGroups: "เลือกกลุ่มก่อน",
      editOneGroupAtOnce: "คุณสามารถแก้ไขได้ทีละหนึ่งกลุ่มเท่านั้น",

      selectStudents: "เลือกนักศึกษาก่อน",
      deleteStudents: "คุณกำลังจะลบนักเรียน",
      editOneStudentAtOnce: "สามารถแก้ไขนักเรียนได้เพียงครั้งละ 1 คน",
      failedToDeleteStudents: "ลบนักเรียนไม่สำเร็จ ลองอีกครั้ง",
      selectTeachers: "กรุณาเลือกครูก่อน",
      deleteTeachers: "คุณกำลังจะลบครู",
      editOneTeacherAtOnce: "คุณสามารถแก้ไขครูได้เพียงครั้งละ 1 คน",
      failedToDeleteTeachers: "ลบครูไม่สำเร็จ ลองอีกครั้ง",
      teacherNames: "กรุณากรอกชื่อและนามสกุลของครู",
      failedUsername: "การสร้างชื่อผู้ใช้ล้มเหลว ลองอีกครั้งในภายหลัง",
      teacherEdit: "ไม่สามารถแก้ไขชื่อผู้ใช้ของครูได้"
    }
  },

  navigation: {
    open: "เปิดเมนู",
    goToDashboard: "ไปที่แดชบอร์ดครู teacher",
    teachers: "ครูผู้สอน",
    students: "นักเรียน",
    lessons: "บทเรียน",
    subgroups: "กำหนดกลุ่มย่อย",
    groups: "กลุ่ม",
    reports: "เครื่องมือสร้างรายงาน",
    grammar: "ไวยากรณ์ที่จะไป",
    knowledge: "ฐานความรู้",
    logout: "ออกจากระบบ"
  }
};
